<style lang="less" scoped>
</style>
<template>
  <div v-if="bfiles&&bfiles.length">
    <v-btn
      v-for="(item,index) in bfiles"
      :key="index"
      text
      @click="downloadFile(item)"
    >
      {{ item.name }}
    </v-btn>
  </div>
</template>
<script>
  import { http } from '../../../../libs/util';
  export default {
    props: {
      bfiles: {
        type: Array
      }
    },
    methods: {
      downloadFile(params) {
        return Util.downloadToBlank({
          id:params.id
        })
      }
    }
  }
</script>
